import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { INITIAL_SHARE_POSITION_STATE } from "./constants";
import { ISharePositionState } from "./interfaces";
import { IInvitation, ISubscriptionWithDescription } from "~/util/providers/share-position/interfaces";

const userSlice = createSlice({
	name: "sharePosition",
	initialState: INITIAL_SHARE_POSITION_STATE,
	reducers: {
		setSubscriptions: (state: ISharePositionState, action: PayloadAction<Array<ISubscriptionWithDescription>>) => {
			state.subscriptions = action.payload;
		},
		setInvitations: (state: ISharePositionState, action: PayloadAction<Array<IInvitation>>) => {
			state.invitations = action.payload;
		},
		setActiveSubscription: (state: ISharePositionState, action: PayloadAction<string>) => {
			state.activeSubscription = action.payload;
		},
		setHoverSubscription: (state: ISharePositionState, action: PayloadAction<string>) => {
			state.hoverSubscription = action.payload;
		},
		toggleActiveSubscription: (state: ISharePositionState, action: PayloadAction<string>) => {
			state.activeSubscription = state.activeSubscription === action.payload ? "" : action.payload;
		},
		setActiveTab: (state: ISharePositionState, action: PayloadAction<ISharePositionState["activeTab"]>) => {
			state.activeTab = action.payload;
		},
		showSubscriptionOnMap: (state: ISharePositionState, action: PayloadAction<string>) => {
			state.subscriptions = state.subscriptions.map(subscription => {
				if (subscription.subscriptionId === action.payload) {
					return {
						...subscription,
						attributes: {
							...subscription.attributes,
							showOnMap: true,
						},
					};
				}

				return subscription;
			});
		},
		hideSubscriptionOnMap: (state: ISharePositionState, action: PayloadAction<string>) => {
			state.subscriptions = state.subscriptions.map(subscription => {
				if (subscription.subscriptionId === action.payload) {
					return {
						...subscription,
						attributes: {
							...subscription.attributes,
							showOnMap: false,
						},
					};
				}

				return subscription;
			});

			if (state.activeSubscription === action.payload) {
				state.activeSubscription = "";
			}
		},
	},
});

// dle "duck" metodiky jsou akce pojmenovane exporty a reducer default export
export const { setSubscriptions, setInvitations, setActiveSubscription, setHoverSubscription, toggleActiveSubscription, setActiveTab, showSubscriptionOnMap, hideSubscriptionOnMap } = userSlice.actions;
export default userSlice.reducer;
